import Vue from 'vue';
import axios from 'axios';
import store from '../store/index';

Vue.prototype.$axios = axios.create({
  baseURL: process.env.VUE_APP_USAVC_API
});

Vue.prototype.$axios.interceptors.request.use(async function (config) {
  const response = await axios.get(process.env.VUE_APP_USAVC_API + 'User/ValidateToken', {
    params: {
      token: store.getters.API_TOKEN
    }
  });
  if (!response.data.data) {
    const response = await axios.post(process.env.VUE_APP_INTERNAL_API + '/api/auth');
    store.dispatch('setApiToken', response.data.token);
  }

  config.headers.Authorization = 'Bearer ' + store.getters.API_TOKEN;
  config.headers.PatientToken = sessionStorage.getItem('patientApiToken');
  config.requestStartTime = Date.now()

  return config;
});

Vue.prototype.$axios.interceptors.response.use(response => {
  response.config.responseTime = (Date.now() - response.config.requestStartTime)/ 1000;
  response.config.sessionId = sessionStorage.getItem('sessionId');

  if (!response.config.url.includes(process.env.VUE_APP_INTERNAL_API)) {
    axios.post(process.env.VUE_APP_INTERNAL_API + '/api/saveApiLoggingData',{
      response : response
    });
  }

  return response
})
